import { useState } from "react";
import { Navigate } from "react-router-dom";
import ModalLogin from "./Header/ModalLogin";
import ModalSignup from "./Header/ModalSignup";
import ModalForgotPassword from "./Header/ModalForgotPassword";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isLoggedIn = !!localStorage.getItem("token");
  const [showLogin, setShowLogin] = useState(!isLoggedIn);
  const [showSignup, setShowSignup] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [redirectHome, setRedirectHome] = useState(false);

  if (isLoggedIn) {
    return <>{children}</>;
  }

  if (redirectHome) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {showLogin && (
        <ModalLogin
          onClose={() => {
            setShowLogin(false);
            setRedirectHome(true);
          }}
          onLoginSuccess={() => {
            window.location.reload();
          }}
          onOpenForgotPassword={() => {
            setShowLogin(false);
            setShowForgot(true);
          }}
          onOpenSignup={() => {
            setShowLogin(false);
            setShowSignup(true);
          }}
        />
      )}
      {showSignup && (
        <ModalSignup
          onClose={() => {
            setShowSignup(false);
            setRedirectHome(true);
          }}
          onOpenLogin={() => {
            setShowSignup(false);
            setShowLogin(true);
          }}
        />
      )}
      {showForgot && (
        <ModalForgotPassword
          onClose={() => {
            setShowForgot(false);
            setRedirectHome(true);
          }}
        />
      )}
    </>
  );
}
